import { loadable } from 'jotai/utils'
import { atom } from 'infrastructure/state/jotai.wrapper'
import { fetchDistrictSchools } from './listQueries'
import { districtIdAtom } from './district.atoms'

// This atom is used to implement the reFresh ability
const perPageAtom = atom(1000)

const districtSchoolsAtom = loadable(
  atom(async (get) => {
    const districtId = get(districtIdAtom)
    if (!districtId) return
    const perPage = get(perPageAtom)
    return fetchDistrictSchools({
      perPage,
      currentPage: 1,
      filters: { districtSearch: districtId.toString() },
      sort: { field: 'id', order: 'asc' },
    })
  }),
)

export const districtSchoolsAtomWithRefresh = atom(
  (get) => {
    const districtSchoolsData = get(districtSchoolsAtom)
    if (districtSchoolsData.state === 'hasData') {
      return districtSchoolsData.data?.data ?? []
    }
    return []
  },
  (get, set) => {
    set(perPageAtom, get(perPageAtom) + 1)
  },
)
